
import { httpRequest } from "@/utils/HttpRequest";
import { ItemDetailed, MaterialDetailed, IRepairTemplateField, IRepairTemplateSearch, IRepairTemplateList, IRepairTemplateDetail, IRepairTemplateRoSettleAndWhConfirm, IRepairTemplateStatistics } from "./repairTemplateType"

class RepairTemplateService {
    async page(searchVo: IRepairTemplateSearch) {
        const apiUrl = "/zzw-vrm/repairTemplate/pageList";
        return await httpRequest.post<IRepairTemplateList>(apiUrl, searchVo);
    }

    async one(id: string) {
        const apiUrl = `/zzw-vrm/repairTemplate/find`;
        return await httpRequest.post<any>(apiUrl, { id });
    }

    async insert(insertVo: IRepairTemplateField) {
        const apiUrl = "/zzw-vrm/repairTemplate/insert";
        return await httpRequest.post<IRepairTemplateDetail>(apiUrl, insertVo);
    }
    async update(updateVo: IRepairTemplateField) {
        const apiUrl = "/zzw-vrm/repairTemplate/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async enable(updateVo: any) {
        const apiUrl = "/zzw-vrm/repairTemplate/enabled";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //导出
    async export(params: IRepairTemplateField) {
        const apiUrl = "/zzw-vrm/repairTemplate/export";
        return await httpRequest.postFile(apiUrl, params);
    }

    //模版导入
    async detialDownloadTpl() {
        const apiUrl = "/zzw-vrm/repairTemplate/downloadTpl";
        return await httpRequest.getFile<boolean>(apiUrl);
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/zzw-vrm/repairTemplate/list/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }
}
export const repairTemplateService = new RepairTemplateService();
